import axios from 'axios'
import urls from '../../util/urls'

const state = {
  listaDeAlugueisDoDia: []
}

const mutations = {
  atualizarListaDeAlugueisDoDia(state, payload) {
    state.listaDeAlugueisDoDia = payload;
  },

  limparAlugueis(state) {
    state.listaDeAlugueisDoDia = [];
  }
}

const actions = {
  recuperarAlugueisDoDia(context) {
    return axios.get(urls.DASHBOARD_RECUPERAR_ALUGUEIS_DO_DIA)
    .then((response) => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarAlugueisDoDia');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return context.commit('atualizarListaDeAlugueisDoDia', response.data.lista);
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}